var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrayQuestionMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7,
    fill: "#2D2943"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15ZM10.0265 4.83608C9.54247 4.49874 8.89714 4.33008 8.09047 4.33008C7.2398 4.33008 6.57247 4.50241 6.08847 4.84708C5.6118 5.19174 5.3258 5.65741 5.23047 6.24408L6.66047 6.83808C6.6898 6.44208 6.8218 6.13774 7.05647 5.92508C7.29847 5.70508 7.61014 5.59508 7.99147 5.59508C8.3728 5.59508 8.6588 5.67574 8.84947 5.83708C9.04747 5.99108 9.14647 6.21108 9.14647 6.49708C9.14647 6.84174 8.99614 7.11308 8.69547 7.31108C8.3948 7.50174 7.89614 7.63374 7.19947 7.70708L7.26547 9.36808H8.60747L8.68447 8.33408C9.31514 8.26808 9.81747 8.07008 10.1915 7.74008C10.5728 7.40274 10.7635 6.91508 10.7635 6.27708C10.7635 5.64641 10.5178 5.16608 10.0265 4.83608ZM8.62947 10.3141C8.4608 10.1601 8.2298 10.0831 7.93647 10.0831C7.64314 10.0831 7.41214 10.1601 7.24347 10.3141C7.08214 10.4681 7.00147 10.6771 7.00147 10.9411C7.00147 11.2051 7.08214 11.4141 7.24347 11.5681C7.41214 11.7221 7.64314 11.7991 7.93647 11.7991C8.2298 11.7991 8.4608 11.7221 8.62947 11.5681C8.79814 11.4141 8.88247 11.2051 8.88247 10.9411C8.88247 10.6771 8.79814 10.4681 8.62947 10.3141Z",
    color: "red",
    fill: "#DEDCE5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrayQuestionMark);
export default __webpack_public_path__ + "static/media/gray-question-mark.961571e8.svg";
export { ForwardRef as ReactComponent };